// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/clipboard-document.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/clipboard-document'

import { Icon, type IconComponentProps } from '../icon'

export const ClipboardDocumentIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
